export function formatDate(isoString, type = 'default') {
  if (!isoString) return '';

  const date = new Date(isoString);
  if (isNaN(date)) return 'Invalid Date';

  const pad = (n) => String(n).padStart(2, '0');
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const map = {
    DD: pad(date.getDate()),
    MM: pad(date.getMonth() + 1),
    
    MMM: months[date.getMonth()],
    YYYY: date.getFullYear(),
    hh: pad(date.getHours() % 12 || 12),
    HH: pad(date.getHours()),
    mm: pad(date.getMinutes()),
    ss: pad(date.getSeconds()),
    A: date.getHours() >= 12 ? 'PM' : 'AM',
  };

  const formats = {
    default: 'DD-MM-YYYY ',
    short: 'DD MMM YYYY',
    long: 'DD MMM YYYY',
    date: 'YYYY-MM-DD',
    time: 'hh:mm A',
    full: 'YYYY-MM-DD ',
    iso: () => isoString, // return as-is
  };

  const formatTemplate = typeof formats[type] === 'function'
    ? formats[type]()
    : formats[type] || formats.default;

  return formatTemplate.replace(/DD|MMM|MM|YYYY|hh|HH|mm|ss|A/g, (token) => map[token]);
}
